import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
import { getIn } from 'formik';
import { SrLabel } from '~helpers';
import Input from './Input';
import FormInputLabel from './input/FormInputLabel';
import FormInputBar from './input/FormInputBar';
import FormInputFeedback from './feedback/FormInputFeedback';
import FormInputAddon from './input/FormInputAddon';
import Container from './Container';
import formPropTypes from '../prop-types/formPropTypes';

var FormInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FormInput, _Component);

  function FormInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleFocus = function () {
      var readOnly = _this.props.readOnly;

      if (!readOnly) {
        _this.setState({
          focused: true
        });
      }
    };

    _this.handleBlur = function (event) {
      var field = _this.props.field;

      _this.setState({
        focused: false
      });

      field.onBlur(event);
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          field = _this$props.field,
          onChange = _this$props.onChange;

      _this.setState({
        filled: !!event.target.value
      });

      field.onChange(event);

      if (onChange) {
        onChange(event);
      }
    };

    _this.handleUpdate = function () {
      _this.setState({
        filled: true
      });
    };

    _this.handleAutoFill = function () {
      _this.setState({
        filled: true
      });
    };

    _this.state = {
      focused: false,
      filled: false
    };
    return _this;
  }

  var _proto = FormInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props2 = this.props,
        form = _this$props2.form,
        field = _this$props2.field;
    var value = getIn(form.values, field.name);

    if (value) {
      this.setState({
        filled: true
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props3 = this.props,
        form = _this$props3.form,
        field = _this$props3.field;
    var value = getIn(form.values, field.name);

    if (value !== '' && !prevState.filled) {
      this.handleUpdate();
    }
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        id = _this$props4.id,
        label = _this$props4.label,
        prependAddon = _this$props4.prependAddon,
        appendAddon = _this$props4.appendAddon,
        field = _this$props4.field,
        form = _this$props4.form,
        type = _this$props4.type,
        autoComplete = _this$props4.autoComplete,
        autoCorrect = _this$props4.autoCorrect,
        autoCapitalize = _this$props4.autoCapitalize,
        spellCheck = _this$props4.spellCheck,
        maxLength = _this$props4.maxLength,
        size = _this$props4.size,
        pattern = _this$props4.pattern,
        inputmode = _this$props4.inputmode,
        disabled = _this$props4.disabled,
        readOnly = _this$props4.readOnly,
        required = _this$props4.required,
        skin = _this$props4.skin,
        hideLabel = _this$props4.hideLabel,
        className = _this$props4.className,
        autoFocus = _this$props4.autoFocus,
        placeholder = _this$props4.placeholder,
        centered = _this$props4.centered;
    var _this$state = this.state,
        focused = _this$state.focused,
        filled = _this$state.filled;
    var error = getIn(form.errors, field.name);
    var value = getIn(form.values, field.name);
    var isSubmitted = form.submitCount > 0;
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SrLabel, {
      htmlFor: id
    }, label), /*#__PURE__*/React.createElement(Input, {
      className: className,
      id: id,
      name: field.name,
      type: type,
      autoComplete: autoComplete,
      autoCorrect: autoCorrect,
      autoCapitalize: autoCapitalize,
      autoFocus: autoFocus,
      spellCheck: spellCheck,
      maxLength: maxLength,
      size: size,
      pattern: pattern,
      inputMode: inputmode,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      value: value,
      disabled: disabled,
      readOnly: readOnly,
      required: required,
      prependAddon: prependAddon,
      appendAddon: appendAddon,
      skin: skin,
      hideLabel: hideLabel,
      placeholder: placeholder,
      onAnimationStart: this.handleAutoFill,
      centered: centered
    }), !hideLabel && /*#__PURE__*/React.createElement(FormInputLabel, {
      requiredValue: required,
      focused: focused,
      filled: filled,
      disabledValue: disabled,
      "aria-hidden": "true",
      skin: skin,
      error: error && isSubmitted,
      isSubmitted: isSubmitted,
      centered: centered
    }, label), /*#__PURE__*/React.createElement(FormInputBar, {
      active: focused,
      skin: skin,
      error: error && isSubmitted,
      isSubmitted: isSubmitted
    }), prependAddon && /*#__PURE__*/React.createElement(FormInputAddon, {
      focused: focused,
      filled: filled,
      disabledValue: disabled,
      skin: skin,
      type: "prepend"
    }, prependAddon), appendAddon && /*#__PURE__*/React.createElement(FormInputAddon, {
      focused: focused,
      filled: filled,
      disabledValue: disabled,
      skin: skin,
      type: "append"
    }, appendAddon), error && isSubmitted && /*#__PURE__*/React.createElement(FormInputFeedback, {
      centered: centered,
      feedbackType: "error",
      id: id,
      message: error,
      skin: skin
    }));
  };

  return FormInput;
}(Component);

FormInput.defaultProps = {
  required: false,
  disabled: false,
  readOnly: false,
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: 'false',
  maxLength: null,
  size: undefined,
  inputmode: null,
  pattern: null,
  prependAddon: null,
  appendAddon: null,
  skin: 'dark',
  hideLabel: false,
  autoFocus: false,
  placeholder: undefined,
  className: undefined,
  centered: false,
  onChange: undefined
};
export default FormInput;